module.exports = require("tty");


//////////////////
// WEBPACK FOOTER
// external "tty"
// module id = 186
// module chunks = 0 1